module.exports = __webpack_public_path__ + "img/sv31.9d490ec5.svg";